import type { SearchParams } from "~www/types/search-params";

import { appendSearchParamsToUrlSearchParams } from "~www/lib/search-params";

const BIO_QUERY_PARAM = "bio";

function buildTeamMemberBioHref({
  basePath,
  memberId,
  searchParams,
}: {
  basePath: string | undefined;
  memberId: string;
  searchParams: SearchParams | undefined;
}): string {
  const params = appendSearchParamsToUrlSearchParams(
    new URLSearchParams(),
    searchParams,
    [BIO_QUERY_PARAM],
  );

  params.set(BIO_QUERY_PARAM, memberId);

  const queryString = params.toString();

  if (!basePath) {
    return `?${queryString}`;
  }

  return `${basePath}?${queryString}`;
}

export { BIO_QUERY_PARAM, buildTeamMemberBioHref };
